var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMedal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Medal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.46992 5.11035C2.46992 7.29188 4.2384 9.06035 6.41992 9.06035C8.60145 9.06035 10.3699 7.29188 10.3699 5.11035C10.3699 2.92883 8.60145 1.16035 6.41992 1.16035C4.2384 1.16035 2.46992 2.92883 2.46992 5.11035Z",
    fill: "#222222",
    stroke: "#E0E0E0",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M3.96992 5.11035C3.96992 6.46345 5.06682 7.56035 6.41992 7.56035C7.77302 7.56035 8.86992 6.46345 8.86992 5.11035C8.86992 3.75725 7.77302 2.66035 6.41992 2.66035C5.06682 2.66035 3.96992 3.75725 3.96992 5.11035Z",
    stroke: "#E0E0E0",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M4.16992 8.48535L4.16992 12.2354L6.41992 11.1104L8.66992 12.2354V8.48535",
    stroke: "#E0E0E0",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMedal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Medal.11b294c4c2c2d326f3bfbab07601ccd4.svg";